import { render, staticRenderFns } from "./DetailVIP.vue?vue&type=template&id=0373bbec&scoped=true&"
import script from "./DetailVIP.vue?vue&type=script&lang=js&"
export * from "./DetailVIP.vue?vue&type=script&lang=js&"
import style0 from "./DetailVIP.vue?vue&type=style&index=0&id=0373bbec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373bbec",
  null
  
)

export default component.exports